export default __webpack_public_path__ + "static/home-product-screenshot-68ca724f159c1e45f185077cef7f93ae.svg";